import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFilterDesc: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFilterDesc"><Path fillRule="evenodd" clipRule="evenodd" d="M3 5H19V7H3V5ZM19 10V16.5858L21 14.5858L22.4142 16L18 20.4142L13.5858 16L15 14.5858L17 16.5858V10H19ZM3 11H12V13H3V11ZM3 17H10V19H3V17Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFilterDesc;
